<script setup lang="ts">
const mockupData = [
    {
        image: '/static/images/red_bull.png',
    },
    {
        image: '/static/images/mcdonalds.png',
    },
    {
        image: '/static/images/swiss.png',
    },
    {
        image: '/static/images/fupa-logo.png',
    },
    {
        image: '/static/images/street.png',
    },
    {
        image: '/static/images/SFC_2019.png',
    },
]
</script>

<template>
    <section>
        <div class="container text-center">
            <div class="row justify-content-center">
                <div class="col-60 col-lg-50">
                    <h2 class="alfa mb-5">
                        Powering 28,500+ clubs, leagues and federations
                        <strong>covering 20+ sports worldwide.</strong>
                    </h2>
                </div>
            </div>

            <ul class="d-grid mb-1 mb-md-0">
                <li v-for="(item, i) in mockupData" :key="`lgs-${i}`">
                    <img
                        :src="item.image"
                        loading="lazy"
                        decoding="async"
                        class="img-fluid"
                        alt=""
                    />
                </li>
            </ul>
        </div>
    </section>
</template>

<style lang="scss" scoped>
@import '../../sass/abstracts/_mixins.scss';

ul {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    position: relative;
    &:after {
        content: '';
        width: 0.1rem;
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: var(--global-color-white);
    }

    &:before {
        content: '';
        width: 100%;
        height: 0.1rem;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: var(--global-color-white);
    }

    @include media-breakpoint-down(md) {
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto;
        gap: 1rem;
    }

    li {
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;
        height: 10.5rem;

        @include media-breakpoint-down(md) {
            border: none;
        }

        img {
            max-width: 7rem;
            vertical-align: middle;
            @include media-breakpoint-only(md) {
                max-width: 5rem;
            }

            @include media-breakpoint-down(md) {
                max-width: 100%;
                max-width: 4rem;
            }
        }
    }
}
</style>
